export default __webpack_public_path__ + "static/media/store.971fa652.svg";